<template>
  <div class="container">
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
      :current='page'
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>数据名称:</label>
            <lk-select v-model='query.data' class="item" clearable>
              <lk-option v-for="item in dataList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button @click="handleClick" type="primary">查询</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>

</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import utils from '../../libs/utils';
import healthInsManage from '../../services/healthInsManage.js';

export default {
  name: 'insDocsDownload',
  mixins: [queryMixins, mapState],
  components: {
    QueryFrame,
  },
  data() {
    return {
      count: 9,
      page: 1,
      query: {},
      tableData: [
        {
          id: 'MED_INSTITUTION_DOWNLOAD',
          name: '医疗机构制剂目录下载'
        },
        {
          id: 'MED_SERVICE_DOWNLOAD',
          name: '医疗服务项目目录下载'
        },
        {
          id: 'DISE_DIAG_DOWNLOAD',
          name: '疾病与诊断目录下载'
        },
        {
          id: 'OPERATE_DOWNLOAD',
          name: '手术操作目录下载'
        },
        {
          id: 'OUT_DISE_DOWNLOAD',
          name: '门诊慢特病种目录下载'
        },
        {
          id: 'DAY_SURGERY_DOWNLOAD',
          name: '日间手术治疗病种目录下载'
        },
        {
          id: 'TUMOR_DOWNLOAD',
          name: '肿瘤形态学目录下载'
        },
        {
          id: 'TCM_DISE_DOWNLOAD',
          name: '中医疾病目录下载'
        },
        {
          id: 'TCM_SYNDROME_DOWNLOAD',
          name: '中医证候目录下载'
        },
      ],
      dataList: [
        {
          id: '1303',
          name: '医疗机构制剂目录下载'
        },
        {
          id: '1305',
          name: '医疗服务项目目录下载'
        },
        {
          id: '1307',
          name: '疾病与诊断目录下载'
        },
        {
          id: '1308',
          name: '手术操作目录下载'
        },
        {
          id: '1309',
          name: '门诊慢特病种目录下载'
        },
        {
          id: '1311',
          name: '日间手术治疗病种目录下载'
        },
        {
          id: '1313',
          name: '肿瘤形态学目录下载'
        },
        {
          id: '1314',
          name: '中医疾病目录下载'
        },
        {
          id: '1315',
          name: '中医证候目录下载'
        },
      ],
      columns: [
        { title: '可下载数据名称', key: 'name', minWidth: 200, tooltip: true, },
        { 
          title: '操作',
          width: 140,
          render: (h, params) => h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            on : {
              click: () => {
                healthInsManage.download({ interfaceNo: params.row.id }).then(res => {
                  utils.downLoadExcel(res, params.row.name, true);
                }).catch(err => {
                  utils.handleError(err);
                })
              }
            }
          }, '下载')
        },
      ],
    }
  },
  methods: {
    handleClick() {},
  },
}
</script>
<style>
  
</style>